"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddAreaLibraryModal = AddAreaLibraryModal;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var area_library_1 = require("../../../features/apis/area-library");
var button_component_1 = require("../../ui/button-component");
var text_component_1 = require("../../ui/text-component");
function AddAreaLibraryModal(props) {
    var _this = this;
    var isOpen = props.isOpen, clientId = props.clientId, onClose = props.onClose, onCreated = props.onCreated;
    var _a = (0, react_2.useState)(""), name = _a[0], setName = _a[1];
    var _b = (0, react_2.useState)(""), error = _b[0], setError = _b[1];
    var _c = (0, area_library_1.useCreateAreaLibraryMutation)(), createAreaLibrary = _c[0], isCreating = _c[1].isLoading;
    var requestTokenRef = (0, react_2.useRef)(0);
    // A synchronous lock also catches a second click before React renders the mutation's loading state.
    var requestInFlightRef = (0, react_2.useRef)(false);
    (0, react_2.useEffect)(function () { return function () {
        requestTokenRef.current += 1;
    }; }, []);
    var handleClose = function () {
        if (requestInFlightRef.current || isCreating) {
            return;
        }
        requestTokenRef.current += 1;
        setName("");
        setError("");
        onClose();
    };
    var handleCreate = function () { return __awaiter(_this, void 0, void 0, function () {
        var trimmedName, requestToken, response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (requestInFlightRef.current || isCreating) {
                        return [2 /*return*/];
                    }
                    setError("");
                    if (!clientId) {
                        setError("Please select an active client before adding an area.");
                        return [2 /*return*/];
                    }
                    trimmedName = name.trim();
                    if (!trimmedName) {
                        setError("Please enter a name.");
                        return [2 /*return*/];
                    }
                    requestToken = requestTokenRef.current;
                    requestInFlightRef.current = true;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, createAreaLibrary({ clientId: clientId, name: trimmedName }).unwrap()];
                case 2:
                    response = _b.sent();
                    if (requestToken !== requestTokenRef.current) {
                        return [2 /*return*/];
                    }
                    if (!response.success) {
                        setError(response.message || "Unable to create area library. Please try again.");
                        return [2 /*return*/];
                    }
                    onCreated === null || onCreated === void 0 ? void 0 : onCreated();
                    requestInFlightRef.current = false;
                    handleClose();
                    return [2 /*return*/];
                case 3:
                    _a = _b.sent();
                    if (requestToken !== requestTokenRef.current) {
                        return [2 /*return*/];
                    }
                    setError("Unable to create area library. Please try again.");
                    return [3 /*break*/, 5];
                case 4:
                    requestInFlightRef.current = false;
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsx)(react_1.Modal, { isOpen: isOpen, onOpenChange: function (open) {
            if (!open)
                handleClose();
        }, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Backdrop, { isDismissable: !isCreating, isKeyboardDismissDisabled: isCreating, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Container, { children: (0, jsx_runtime_1.jsxs)(react_1.Modal.Dialog, { className: "sm:max-w-[480px]", children: [(0, jsx_runtime_1.jsx)(react_1.Modal.CloseTrigger, { isDisabled: isCreating, onPress: handleClose }), (0, jsx_runtime_1.jsx)(react_1.Modal.Header, { children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "large", color: "dark-gray-1", weight: "bold", label: "Add Area" }) }), (0, jsx_runtime_1.jsxs)(react_1.Modal.Body, { className: "p-1", children: [(0, jsx_runtime_1.jsx)(react_1.TextField, { "aria-label": "Area Name", value: name, onChange: setName, isRequired: true, children: (0, jsx_runtime_1.jsx)(react_1.Input, { placeholder: "Area name", className: "rounded-md" }) }), error && ((0, jsx_runtime_1.jsx)("div", { role: "alert", children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "red-600", label: error }) }))] }), (0, jsx_runtime_1.jsxs)(react_1.Modal.Footer, { children: [(0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Cancel", onPress: handleClose, isDisabled: isCreating, variant: "secondary" }), (0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Add Area Library", onPress: handleCreate, isPending: isCreating, isDisabled: !clientId || !name.trim(), color: "white", backgroundColor: "primary-navy", hoverColor: "primary-navy-light" })] })] }) }) }) }));
}
